module.exports = __webpack_public_path__ + "img/individual_weddingrings_spread@2x.5b8c7c1.webp";